<template>
  <div class="app-bar" :class="{ 'mt-10': isImpersonating }">
    <a href="#app-content" class="skip-link" tabindex="1">
      Skip to main content
    </a>
    <div class="d-flex align-center">
      <NavigationAccountMenu />
      <v-menu v-if="showMobileMenu">
        <template v-slot:activator="{ on }">
          <div v-on="on" class="mx-5">
            <v-icon color="primary">
              mdi-menu
            </v-icon>
          </div>
        </template>
        <v-list>
          <v-list-item-group class="my-2">
            <Permissioned vertical>
              <NavigationItem
                v-for="(item, index) in navigationItems"
                :key="index"
                :item="item"
                :organisationUnitId="organisationUnitId"
                :permission="item.permission"
              />
            </Permissioned>
          </v-list-item-group>
        </v-list>
      </v-menu>
    </div>
    <Permissioned class="mx-5 navigation-container" v-if="!showMobileMenu">
      <NavigationItem
        v-for="(item, index) in navigationItems"
        :key="index"
        :item="item"
        :organisationUnitId="organisationUnitId"
        :permission="item.permission"
      />
    </Permissioned>
    <Permissioned class="settings-nav-item">
      <NavigationItem
        :item="userGuideNavigationItem"
        permission="manual.view"
      />
      <NavigationItem
        :item="settingsNavigationItem"
        :permission="settingsNavigationItem.permission"
      />
    </Permissioned>
  </div>
</template>

<script>
import Permissioned from "@/components/common/Permissioned";
import {
  MAIN_NAVIGATION_ITEMS,
  SETTINGS_NAVIGATION_ITEM,
  USER_GUIDE_NAVIGATION_ITEM
} from "@/constants/navigation";
import NavigationItem from "@/components/navigation/components/NavigationItem";
import NavigationAccountMenu from "@/components/navigation/components/NavigationAccountMenu";
import { createNamespacedHelpers } from "vuex";
import { AUTH_NAMESPACE } from "@/store/modules/auth";
import { getImpersonateUserId } from "@/services/utils";

const { mapState } = createNamespacedHelpers(AUTH_NAMESPACE);

export default {
  components: { Permissioned, NavigationItem, NavigationAccountMenu },
  computed: {
    ...mapState({
      user: state => state.userData,
      permissions: state => state.permissions
    }),
    helpCentreLink() {
      return this.helpCentreLinks[this.user.accountType];
    },
    showMobileMenu() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    isImpersonating() {
      return Boolean(getImpersonateUserId());
    },
    organisationUnitId() {
      return this.user.organisation && this.user.organisation.id;
    }
  },
  data() {
    return {
      navigationItems: MAIN_NAVIGATION_ITEMS,
      settingsNavigationItem: SETTINGS_NAVIGATION_ITEM,
      userGuideNavigationItem: USER_GUIDE_NAVIGATION_ITEM
    };
  }
};
</script>

<style lang="scss">
.app-bar {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
  margin-bottom: 20px;
  align-items: center;
  z-index: 10;

  .settings-nav-item {
    min-width: fit-content;
  }

  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
    .navigation-container {
      justify-content: flex-start;
      width: 100%;
    }
    .settings-nav-item {
      min-width: 100px;
    }
  }

  @media only screen and (max-width: $mobile-breakpoint - 1) {
    margin-bottom: 15px;
  }
}

a.skip-link {
  position: absolute;
  font-weight: bold;
  background-color: #fff;
  padding: 15px;
  transform: translateY(-200%);

  &:focus {
    display: block;
    transform: translateY(0%);
  }

  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
    display: none;
  }
}

.v-list-item--link:focus {
  background-color: #e2eaf8;

  .v-list-item__title {
    color: #1a4499;
  }

  .v-icon {
    color: #1a4499 !important;
  }
}

.theme--light.v-list-item--link:focus:before {
  opacity: 0;
}
</style>
